@use "~theme/breakpoints";
@use "~theme/typography";

.container {
  padding: 24px 24px 40px;

  @include breakpoints.desktop {
    padding: 32px 40px 40px;
  }
}

.card {
  box-sizing: border-box;
  position: relative;
  display: grid;
  gap: 24px;
  border: 1px solid var(--blue-01-at-30);
  padding: 16px 28px;
  border-radius: 4px;
  background-color: var(--blue-03-at-30);
  width: 100%;
}

.cardTitle {
  @include typography.body-semibold;
}

.rule {
  position: relative;
  top: 0.2em;
  border: none;
  margin: 0;
  border-top: 1px solid var(--blue-01-at-30);
}

.imageContainer {
  display: flex;
  margin-right: 20px;
  justify-content: left;
  flex-shrink: 0;
}

.infoContainer {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 16px;

  @include breakpoints.mobile-large {
    flex-direction: row;
    align-items: flex-start;
  }
}

.details {
  min-width: 0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.semibold {
  margin-bottom: 7px;

  @include typography.body-semibold;
}
